<template>
  <v-footer v-bind="$attrs" color="transparent">
    <p
      class="text-center mx-auto mb-0"
      :class="{
        'white--text onSmall': $vuetify.breakpoint.smAndDown && $route.name === 'auth',
        'body-2 grey--text text--darken-1': !(
          $vuetify.breakpoint.smAndDown && $route.name === 'auth'
        ),
      }"
      :style="white ? 'color: white !important;' : ''"
    >
      All Right Reserved Arches Language School ©2021
    </p>
  </v-footer>
</template>

<script>
export default {
  name: "Copyright",
  components: {},
  props: {
    white: Boolean,
  },
  data: () => ({}),
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.onSmall {
  font-size: 11px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #45459a8e;
}
</style>
